// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"142b32a6","488":"c2f99975","783":"e3ec9662","823":"896151f8","860":"fa446f97","949":"359b3942","956":"6b44be4a"}[chunkId] + ".chunk.js";
};